var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrendingDown = function SvgTrendingDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#154199",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M28.75 22.5 16.875 10.625l-6.25 6.25L1.25 7.5m27.5 15h-7.5m7.5 0V15"
  })));
};
export default SvgTrendingDown;